// extracted by mini-css-extract-plugin
export default {"wrapper":"L","center":"M"};